'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <tbody> element
var styles = function styles() {
  return '\n  flex: 1;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Body', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles);


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ListTable/Body.js
// module id = 1595
// module chunks = 2